import { z } from 'zod';
import { EventListItemDto } from './event';

export const MyCalendarDayDto = z.object({
  ymd: z.iso.date(),
  entries: z.array(EventListItemDto),
});
export type MyCalendarDayDto = z.infer<typeof MyCalendarDayDto>;

export const MyCalendarResponseDto = z.object({
  timezone: z.string().min(1),
  fromYmd: z.iso.date(),
  toYmd: z.iso.date(),
  days: z.array(MyCalendarDayDto),
});
export type MyCalendarResponseDto = z.infer<typeof MyCalendarResponseDto>;
